import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  OnInit,
} from '@angular/core';
import { ReqService } from '@core/services';
import { AlertContentComponent } from '@commons/alert-content/alert-content.component';
import { RefundableRateComponent } from '../refundable-rate/refundable-rate.component';
import { PaymentMethodSelectorComponent } from '../payment-method-selector/payment-method-selector.component';
import { NgIf } from '@angular/common';

@Component({
    selector: 'detail-filters-mobile',
    templateUrl: './detail-filters-mobile.component.html',
    styleUrls: ['./detail-filters-mobile.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        PaymentMethodSelectorComponent,
        RefundableRateComponent,
        AlertContentComponent,
    ],
})
export class DetailFiltersMobileComponent implements OnInit, OnChanges {
  @Input()
  refundableRateSelected: boolean;
  @Input()
  selectedPaymentMethod: any;
  @Input()
  isDisney: boolean;
  @Input()
  hotelAvailabilityInfo: any;
  @Input()
  showRefundableRateAlert: boolean;
  @Input()
  showPaymentsOptionsAlert: any;
  @Input()
  showChangedPricesAlert: any;
  @Output()
  paymentMethodChange: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  refundableRateChange: EventEmitter<any> = new EventEmitter<any>();

  private allRooms: any;
  public showPaymentMethodSelector: boolean;
  public showRefundableRateSwitch: boolean;
  public openRefundableRateAlert: any;
  public openPaymentsMethodsAlert: any;
  public openChangedPricesAlert: any;
  public brand: string;
  private brandImages: Array<string> = ['avantrip'];

  constructor(private reqService: ReqService) {}

  ngOnInit() {
    const brand = this.reqService.getBrand();
    if (this.brandImages.includes(brand)) {
      this.brand = brand;
    } else {
      this.brand = 'almundo';
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hotelAvailabilityInfo && !changes.hotelAvailabilityInfo.isFirstChange()) {
      this.checkComponentVisibility();
    }
    if (
      changes.showChangedPricesAlert &&
      !changes.showChangedPricesAlert.isFirstChange()
    ) {
      this.openChangedPricesAlert = changes.showChangedPricesAlert.currentValue;
    }
    if (
      changes.showRefundableRateAlert &&
      !changes.showRefundableRateAlert.isFirstChange()
    ) {
      this.openRefundableRateAlert = changes.showRefundableRateAlert.currentValue;
    }
    if (
      changes.showPaymentsOptionsAlert &&
      !changes.showPaymentsOptionsAlert.isFirstChange()
    ) {
      this.openPaymentsMethodsAlert = changes.showPaymentsOptionsAlert.currentValue;
    }
  }

  /**
   * Checks component visibility
   */
  private checkComponentVisibility() {
    this.allRooms = this.hotelAvailabilityInfo.prepaid_room_clusters.concat(
      this.hotelAvailabilityInfo.paid_at_destination_room_clusters,
    );
    this.showRefundableRateSwitch =
      !this.isDisney && this.checkRefundableRateVisibility();
    this.showPaymentMethodSelector =
      !this.isDisney &&
      this.hotelAvailabilityInfo.prepaid_room_clusters.length &&
      this.hotelAvailabilityInfo.paid_at_destination_room_clusters.length;
  }

  /**
   * Checks refundable rate component visibility
   */
  private checkRefundableRateVisibility() {
    let refundable = false;
    let nonrefundable = false;
    this.allRooms.forEach((room) => {
      if (room.rates.some((rate) => rate.refundable)) {
        refundable = true;
      }
      if (room.rates.some((rate) => !rate.refundable)) {
        nonrefundable = true;
      }
    });
    return refundable && nonrefundable;
  }

  /**
   * Emits payment method change
   */
  public changePaymentMethod(data) {
    this.paymentMethodChange.emit(data);
  }

  /**
   * Emits refundable rate method change
   */
  public changeRefundableRate(data) {
    this.refundableRateChange.emit(data);
  }
}
